import { object, string } from "yup";

export const loginValidationSchema = object({
    email: string()
        .email("Please enter a valid email")
        .required("Email required"),
    password: string().required("Please enter your password"),
});
